module.exports = __webpack_public_path__ + "public/images/header/image.1e718d837d379ea2c20e85f777b0f1d7.jpg";